/* SupportingMedia.tsx generated by @compiled/babel-plugin v0.36.0 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { media } from '@atlaskit/primitives';
import { H4, MediaFilmstrip } from '@atlassian/mpac-primitives';
import * as React from 'react';
import { TEST_ID as APP_LISTING_TEST_IDS } from '../constants';
import { getMediaItems } from '../useMedia';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const _5 = "@media (min-width:64rem){._isu41k7u{margin-bottom:3.5rem}}";
const _4 = "._otyroahv{margin-bottom:var(--ds-space-600,3pc)}";
const _3 = "._2lx21bp4{flex-direction:column}";
const _2 = "._1e0c1txw{display:flex}";
const _ = "._zulpv47k{gap:var(--ds-space-250,20px)}";
const Container = null;
export const SupportingMedia = props => {
  const {
    screenshots,
    onMediaItemClick
  } = props;
  if (!screenshots.length) return null;
  const screenshotMedia = getMediaItems([], screenshots);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5]
    }), /*#__PURE__*/_jsxs("div", {
      "data-testid": APP_LISTING_TEST_IDS.GALLERY,
      className: ax(["_zulpv47k _1e0c1txw _2lx21bp4 _otyroahv _isu41k7u"]),
      children: [/*#__PURE__*/_jsx(H4, {
        as: "h2",
        children: "Supporting media"
      }), /*#__PURE__*/_jsx(MediaFilmstrip, {
        items: screenshotMedia,
        handleMediaClick: onMediaItemClick
      })]
    })]
  });
};